export const currencyTypes = {
  USD: 'USD',
  EUR: 'EUR',
};
